import { render, staticRenderFns } from "./ConvenioCronogramaRecebimento.vue?vue&type=template&id=31219b36"
import script from "./ConvenioCronogramaRecebimento.vue?vue&type=script&lang=js"
export * from "./ConvenioCronogramaRecebimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports